<template>
  <Layout :key="key">
    <template #header-container>
      <PageHeader :title="title" isSticky>
        <template #afterTitle>
          <McButtonBack />
        </template>
      </PageHeader>
    </template>

    <!-- Template Detail -->
    <DetailInfoSection
      ref="detail-info-section"
      :totalWeights="totalWeights"
      @update:totalWeights="handleChangeTotalWeights"
      @update:totalVolumes="handleChangeTotalVolumes"
      @update:templateName="templateName = $event"
      @refetch-data="key += 1"
    />

    <!-- Loads Table -->
    <LoadsTable
      :apiClient="loadApiClient"
      :totalWeights="totalWeights"
      :totalVolumes="totalVolumes"
      @update:totalWeights="handleChangeTotalWeights"
      @update:totalVolumes="handleChangeTotalVolumes"
    />
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McButtonBack from '@/components/McButtonBack'

import DetailInfoSection from './contents/DetailInfoSection'
import LoadsTable from './contents/LoadsTable'

import * as TemplateDeliveryOrder from '@/services/rest-api/lib/delivery/template'

export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    DetailInfoSection,
    LoadsTable,
  },
  data() {
    return {
      key: 1,
      totalWeights: 0,
      totalVolumes: 0,

      templateName: '',
    }
  },
  computed: {
    templateId() {
      return this.$route.params.id
    },
    title() {
      if (this.templateId === undefined) {
        return 'Template Pengiriman Baru'
      }

      return `Template ${this.templateName}`
    },
    loadApiClient() {
      return {
        get: TemplateDeliveryOrder.getLoad(this.templateId),
        show: TemplateDeliveryOrder.showLoad(this.templateId),
        update: TemplateDeliveryOrder.updateLoad(this.templateId),
        store: TemplateDeliveryOrder.storeLoad(this.templateId),
        delete: TemplateDeliveryOrder.deleteSingleLoad(this.templateId),
      }
    },
  },
  watch: {
    templateId(newValue, oldValue) {
      if (newValue === oldValue) return
      this.key += 1
    },
  },
  methods: {
    handleChangeTotalWeights(event) {
      this.totalWeights = event
    },
    handleChangeTotalVolumes(event) {
      this.totalVolumes = event
    },
  },
}
</script>
